import React from 'react';
import PropTypes from 'prop-types';
import { Modal as BootstrapModal } from 'react-bootstrap5';

export default function ModalWithoutWrapper({
  show, size, onHide, children,
}) {
  return (
    <BootstrapModal
      show={show}
      keyboard
      onHide={onHide}
      size={size}
    >
      {children}
    </BootstrapModal>
  );
}

ModalWithoutWrapper.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  onHide: PropTypes.func,
};

ModalWithoutWrapper.defaultProps = {
  size: null,
  onHide: () => {},
};
